<div class="cart-side-panel">
  <div class="cart-side-panel__header">
    <span class="cart-side-panel__title">Cart</span>
    <button ftrIconButton icon="Close" (click)="closePanel.emit()">Close</button>
  </div>
  <hr class="cart-side-panel__separator" />
  <div class="cart-side-panel__groups">
    @for (group of cartGroups(); track group.key) {
      <ftr-request-cart-group [group]="group" displayType="small">
        <ng-template #itemTemplate let-item [ftrTypedContext]="group.items">
          <ftr-cart-times-display [requestedTimes]="item.requestedTimes" [maxVisible]="1" />
        </ng-template>
      </ftr-request-cart-group>
    } @empty {
      <div class="cart-side-panel__empty-state">
        <ftr-empty-state
          message="Browse content to start adding recordings to your cart."
          icon="Cart"
          displayTitle="No Items in Cart"
        />
      </div>
    }
  </div>
  @if (cartGroups().length > 0) {
    <hr class="cart-side-panel__separator" />
    <div class="cart-side-panel__buttons">
      <a ftrButton color="secondary" [fullWidth]="true" [routerLink]="cartPath()" (click)="closePanel.emit()">
        Go to cart
      </a>
      <a ftrButton color="primary" [fullWidth]="true" [routerLink]="checkoutPath()" (click)="closePanel.emit()"
        >Request</a
      >
    </div>
  }
</div>
